import { useDispatch, useSelector } from 'react-redux';
import styles from './ImageScanSearch.module.scss';
import {
  curatorActions,
  selectedIsImageScanSearchOpen,
} from '../../redux/slicers/admin/curatorSlicer';
import { ModalArea } from '../../common/ModalButtonArea';
import MyDropzone from '../MyDropzone';
import { v4 as uuidv4 } from 'uuid';

export const ImageScanSearchModal = () => {
  const open = useSelector(selectedIsImageScanSearchOpen);
  if (!open) return null;
  return <ImageScanSearchModalUI show={open} />;
};

const ImageScanSearchModalUI = ({ show }) => {
  const dispatch = useDispatch();

  const onClose = () => dispatch(curatorActions.toggleImageScanSearchOpen());

  const handleFileChange = (files) => {
    const file = files?.[0];

    const reader = new FileReader();
    reader.addEventListener('load', () => {
      const img = new Image();
      img.src = reader.result;

      img.onload = () => {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');

        // Set the desired width and height for the reduced image
        const maxWidth = 1500;
        const maxHeight = 1500;

        let width = img.width;
        let height = img.height;

        if (width > height) {
          if (width > maxWidth) {
            height *= maxWidth / width;
            width = maxWidth;
          }
        } else {
          if (height > maxHeight) {
            width *= maxHeight / height;
            height = maxHeight;
          }
        }

        canvas.width = width;
        canvas.height = height;

        ctx.drawImage(img, 0, 0, width, height);

        const reducedBase64 = canvas.toDataURL('image/jpeg', 0.8); // Change the format and quality if needed

        const _file = { id: uuidv4(), file, url: reducedBase64 };
        dispatch(curatorActions.setImageScanSearchFile(_file));
        onClose();
      };

      // const _file = { id: uuidv4(), file, url: reader.result?.toString() || '' }
      // dispatch(curatorActions.setImageScanSearchFile(_file))
      // onClose();
    });
    reader.readAsDataURL(file);
  };

  return (
    <ModalArea
      showModal={show}
      setShowModal={onClose}
      className=""
      parentClassName={styles.imageSearchModalWrapper}
      title="Search by Image"
      size="lg"
      modalClassName="add-to-collection-dialog"
      centered={true}
      body={
        <MyDropzone
          title="Upload Image"
          subTitle="or drag and drop an image here"
          onDrop={handleFileChange}
          restrictMultiple={true}
          noInlineStyle={true}
        />
      }
    />
  );
};
